<template>
    <div class="course-container">
        <el-row class="course" type="flex">
            <img :src="course.ConverImg"
                 alt="course-cover-default"
                 v-if="course.ConverImg"
                 style="width: 290px; height: 170px"/>
            <img src="@/assets/img/course-cover.png"
                 alt="course-cover-default"
                 v-else
                 style="width: 290px; height: 170px"/>
            <div class="courseInfo">
                <div class="title">{{course.SourceName}}</div>
                <div class="desc">{{course.Content}}</div>
                <div class="time" v-if="course.StartTime && course.EndTime">{{course.StartTime}} - {{course.EndTime}}</div>
                <template v-if="course.RateOfProgress != null">
                    <el-row type="flex" justify="space-between" style="margin-top: 20px" align="middle">
                        <el-progress :percentage="course.RateOfProgress"
                                     :stroke-width="10"
                                     style="flex: 1"
                                     color="#FFB351"
                                     :show-text="false">
                        </el-progress>
                        <span style="color: #FFB351; margin-left: 10px"
                              class="font-size14">已学习 {{course.RateOfProgress}}%</span>
                    </el-row>
                </template>
            </div>
            <button class="btn-reset study-btn"
                    v-if="course.IsMy && course.IsLearnTime"
                    @click.stop="startStudy">{{course.RateOfProgress > 0 ? "继续学习" : "开始学习"}}</button>
<!--            <button v-if="course.IsMy && !course.IsLearnTime" class="btn-reset noStudy" disabled>-->
<!--                课程还未开始-->
<!--            </button>-->
            <div class="questionnaire-status"
                 :class="parseInt(course.RateOfProgress) === 100 ? 'is-complete' : undefined"
                 v-if="course.Credit != null">
                {{course.Credit}}分
            </div>
        </el-row>
        <div class="border-line"></div>
    </div>
    <!-- 课程列表 -->
</template>

<script>
export default {
    name: "CourseItem",
    props: {
        course: {
            type: Object,
            default () {
                return {}
            }
        },
        index: {
            type: Number,
            default () {
                return 0
            }
        }
    },
    methods: {
        startStudy () {
            this.$emit("start-study", this.course)
        }
    }
}
</script>

<style scoped lang="less">
.course-container {
    padding: 20px 10px;
    box-sizing: border-box;
}
.course {
    box-sizing: border-box;
    width: 100%;
    position: relative;
    .courseInfo {
        margin-left: 40px;
        margin-right: 20px;
        flex: 1;
        .title {
            font-weight: 600;
            font-size: 18px;
            margin-bottom: 10px;
        }
        .desc {
            font-size: 14px;
            margin-bottom: 20px;
            color: #72777F;
        }
        .time {
            font-size: 14px;
            color: #C4C9D7;
        }
    }
    .study-btn {
        background-image: linear-gradient(270deg, #4987FF 0%, #4CA5FA 100%);
        border-radius: 18px;
        color: #fff;
        margin-left: auto;
        align-self: center;
    }
}
.border-line {
    height: 8px;
    box-sizing: border-box;
    background-color: #F1F2F6;
    width: 100%;
    margin-top: 20px;
}
.questionnaire-status {
    position: absolute;
    top: 10px;
    left: 0;
    padding: 6px 26px;
    border-radius: 0 16px 16px 0;
    background-color: #BABFCB;
    color: #fff;
    font-size: 14px;
    &.is-complete {
        background-image: linear-gradient(270deg, #4987FF 0%, #4CA5FA 100%);
    }
}
.noStudy {
    color: #fff;
    background-color: #c0c4cc;
    border-radius: 18px;
    margin-left: auto;
    align-self: center;
}
</style>
